<template>
    <div class="battery" :class="classes">
        <span class="bg"><span class="inner" :style="{width: value + '%'}"></span></span>
        <span class="fg">
            <span v-if="value > 0 && !isSmall">{{ value | toReadableString }} %</span>
            <span v-if="value <= 0">{{ $t('availabilities.nonAvailable') }}</span>
        </span>
    </div>
</template>

<script>
    import filters from '../../../filters';

    export default {
        name: 'battery',

        filters: filters,

        props: {
            value: {
                type: Number,
                'default': 0,
            },
            isSmall: {
                type: Boolean,
                'default': false,
            },
        },

        computed: {
            classes() {
                return Object.assign({}, this.$getBackgroundColorClass(this.value), {'is-small': this.isSmall});
            },
        },
    };
</script>

<style lang="scss">
    @import './battery.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/availabilities/battery.vue